import React from 'react';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Loader } from '@/components/custom/loader';

export function ProfessorsSection({ professors, loading }) {
  return (
    <section className="rounded-2xl border border-neutral-lightest bg-white p-4 shadow-card">
      <h2 className="mb-1 text-xs font-extrabold uppercase tracking-wide text-neutral-dark">Mentores e professores</h2>

      {loading && <Loader />}

      <div className="flex flex-col">
        {!loading &&
          professors?.map(professor => (
            <div
              key={professor.id}
              className="flex items-center gap-3 border-b border-neutral-lightest py-2.5 last:border-b-0 last:pb-0"
            >
              <AvatarWrapper
                size="sm"
                src={professor?.image?.url}
                text={professor?.name}
              />
              <div className="min-w-0">
                <p className="mb-0 truncate text-sm font-extrabold text-neutral-900">{professor?.name}</p>
                <p className="mb-0 truncate text-sm text-neutral-dark">{professor?.['profile-names']?.[0] || professor?.profiles?.[0]?.name}</p>
              </div>
            </div>
          ))}
      </div>
    </section>
  );
}
